import React, { useContext, useEffect, useRef, useState } from 'react';
import { AuthContextAdmin } from './AuthContext';
import { Col, Container, Row } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

const LoginComponentAdmin = () => {
  const { login, error, isAuthenticated } = useContext(AuthContextAdmin);
  const [password, setPassword] = useState('');
  const focusInputRef = useRef(null);

  useEffect(() => {
    focusInputRef.current.focus();
  }, []);

  const handleLogin = (event) => {
    event.preventDefault();
    login(password);
  };

  if (isAuthenticated) {
    // Redirect if user is authenticated
    return <Navigate to="/managelist" />;
  }

  return (
    <Container fluid>
      <Row>
        <Toaster />
        <Col
          className="text-center"
          style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div className="p-2">
            <h6 className="h5">Admin Log In</h6>
          </div>
          <form onSubmit={handleLogin}>
            <div className="form-floating mb-3">
              <input
                id="password"
                className="form-control"
                type="password"
                placeholder="Password"
                value={password}
                ref={focusInputRef}
                onChange={(e) => setPassword(e.target.value)}
              />
              <label htmlFor="password">Password</label>
            </div>
            <button type="submit" className="btn btn-primary">
              Sign in
            </button>
          </form>
          {error && <p>{error}</p>}
        </Col>
      </Row>
    </Container>
  );
};

export default LoginComponentAdmin;
